document.addEventListener("sections:loaded", () => {
  const targets = document.querySelectorAll("[data-product-delivery-date]");

  if (targets.length === 0) {
    return;
  }

  const ordinalSuffix = (day) => {
    if (day % 100 >= 11 && day % 100 <= 13) {
      return "th";
    }
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  // Cutoff: Monday-Friday orders placed before 16:00 ship next day; everything
  // else (weekday after 16:00, or a weekend order) ships the day after that.
  // The carrier doesn't deliver Sunday or Monday, so if that lands on either,
  // push forward to the next available day (Tuesday at the earliest) — this
  // is also what makes Saturday/Sunday orders land on Tuesday specifically.
  const getDeliveryDate = () => {
    const now = new Date();
    const day = now.getDay();
    const hour = now.getHours();
    const isWeekday = day >= 1 && day <= 5;
    const daysToAdd = isWeekday && hour < 16 ? 1 : 2;

    const deliveryDate = new Date(now);
    deliveryDate.setDate(deliveryDate.getDate() + daysToAdd);

    while (deliveryDate.getDay() === 0 || deliveryDate.getDay() === 1) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }

    return deliveryDate;
  };

  const deliveryDate = getDeliveryDate();

  targets.forEach((target) => {
    const isDutch = target.dataset.locale === "nl";
    const locale = isDutch ? "nl-NL" : "en-US";
    const weekday = deliveryDate.toLocaleDateString(locale, { weekday: "long" });
    const month = deliveryDate.toLocaleDateString(locale, { month: "long" });
    const dayNumber = deliveryDate.getDate();

    target.textContent = isDutch
      ? `${weekday} ${dayNumber} ${month}`
      : `${weekday}, ${dayNumber}${ordinalSuffix(dayNumber)} ${month}`;
  });
});
